import GeneralServices from "./GeneralServices";

import {
  MediatorInfoRequestDto,
  IGetSendaUserResponse,
  IResponseError, 
  IGetSendaUserRequest} from "./dto/request/MediatorServiceRequest.dto";
import { IMediator } from "../models/mediator-model";
import { deepGet } from "../utils/utility";

class MediatorServices {
  loginGoogle = async (args: any) => {
    try {
      const res = await GeneralServices.post({
        loader: true,
        setLoading: args.setLoading,
        data: args.data,
        endpoint: "auth/socialNetworkLogin"
      });

      return res.data;
    } catch (err) {
      throw err;
    }
  };

  login = async (args: any) => {
    try {
      const res = await GeneralServices.post({
        loader: true,
        setLoading: args.setLoading,
        data: args.data,
        endpoint: "auth/login"
      });

      return res.data;
    } catch (err) {
      throw err;
    }
  };

  getProfile = async (args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: args.loader && (args.loader === false ? false : true),
        endpoint: `auth/profile`
      });
      return response.data;
    } catch (err) {
      return {};
    }
  };

  getMediatorInfo = async (args: MediatorInfoRequestDto): Promise<IMediator> => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: args.loader && (args.loader === false ? false : true),
        endpoint: `auth/mediatorInfo/${args.mediatorCode}${args.productPermissionCheck ? `?productPermissionCheck=true`:''}`
      });
      return response.data;
    } catch (err) {
      throw err;
    }
  };

  getSendaUser = async (args: IGetSendaUserRequest): Promise<IGetSendaUserResponse | IResponseError> => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: !!args.loader,
        endpoint: `auth/profile?user=${args.user}`,
      });
      return {
        ok: true,
        data: response.data,
      }
    } catch (error) {
      const warnings: any = deepGet(error, "data.errors.warnings", []);
      const msg = (warnings && warnings.length > 0) ? warnings[0].description : undefined;
      return {
        error: true,
        message:
          typeof msg === "string" ? msg : "El usuario indicado no existe o no tiene permisos para modificarlo.",
      };
    }
  }
}

export default new MediatorServices();
